import React from 'react'
import { ReactComponent as GetSuccessIllustration } from 'assets/illustrations/GetSuccessIllustration.svg'
import { Email } from 'components/forms/Email'
import { Typography } from 'transfix-ui/core'

export const SuccessPage = () => {
  const successHeader = 'Request for detention submitted successfully!'
  const email = 'detention@transfix.io'
  const SuccessMessage = () => (
    <span>
      A confirmation of this request will be sent to the dispatcher on file for this account within
      the next 30 minutes. Please contact the transfix team at{' '}
      <Email email={email} title={email} subject='' /> with any questions or concerns.
    </span>
  )

  return (
    <div className='container mt8'>
      <div className='col-xs-12 flex justify-center items-center'>
        <div className='col-xs-6'>
          <div className='col-xs-12 flex justify-center'>
            <GetSuccessIllustration />
          </div>
          <div className='col-xs-12 flex justify-center'>
            <Typography variant='h2'>{successHeader}</Typography>
          </div>
          <div className='col-xs-12 tc flex justify-center text-wrap'>
            <SuccessMessage />
          </div>
        </div>
      </div>
    </div>
  )
}
